import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { RoleGuard } from "app/guards";
import { TelefonosProvider } from "./telefonos-context";
import { TelefonosTable } from "./telefonos-table";
import { TelefonoForm } from "./telefono-form";

export function TelefonosRoutes() {
  return (
    <RoleGuard roles={["empresa:telefonos"]}>
      <TelefonosProvider>
        <Routes>
          <Route path="/" element={<Outlet />}>
            <Route index element={<TelefonosTable />} />

            <Route path="add" element={<TelefonoForm />} />

            <Route path=":telefono_id" element={<Outlet />}>
              <Route index element={<Navigate to="edit" replace />} />

              <Route path="edit" element={<TelefonoForm />} />
            </Route>

            <Route path="*" element="Telefonos: Page Not Found" />
          </Route>
        </Routes>
      </TelefonosProvider>
    </RoleGuard>
  );
}
